(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('DeleteImportDialogController', DeleteImportDialogController);

    function DeleteImportDialogController($scope, $mdDialog, $mdMedia, $translate, $sanitize, $sce) {

        const importableEntityMap = {
            account: 'accounts',
            opportunity: 'opportunities',
            contact: 'contacts'
        };
        const importId = this.importId;

        $scope.deleteUpdatedObject = { deleteUpdated: false };
        $scope.importType = this.importType;
        $scope.entityName = importableEntityMap[this.importType];
        $scope.textMap = {
            account: {
                warning: $translate.instant('if there are opportunities linked to these accounts, they will also be deleted.')
            }
        };

        $scope.updateTranslatedStrings = function () {
            const entityNameTranslated = $translate.instant($scope.entityName);
            $scope.allNewEntitiesText = $sanitize($translate.instant('All <b>new</b> {{entityName}} associated with this import will be deleted.', {
                entityName: entityNameTranslated
            }));
            $scope.alsoDeleteUpdatedText = $sanitize($translate.instant('Also delete contacts that were <b>updated</b> by this import'));
            $scope.entityToBeDeleted = $translate.instant('to see which {{entityName}} will be deleted .', { entityName: entityNameTranslated });
        };

        $scope.updateTranslatedStrings();

        $scope.$on('$translateChangeSuccess', function () {
            $scope.updateTranslatedStrings();
        });

        $scope.cancel = $mdDialog.cancel;

        /**
         * Returns sanitized and trusted HTML for "You can check here ..." with link.
         * Uses {{entityText}} for the dynamic "to see which X will be deleted" part (escaped by escapeParameters).
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getCheckHereHtml = function () {
            const entityText = ($scope.entityToBeDeleted ? ' ' + $scope.entityToBeDeleted : '');
            const raw = $translate.instant('You can check <a href="">here</a> {{entityText}}', { entityText });
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Delegates clicks on the "here" link (inside ng-bind-html).
         *
         * @param {Object} $event - Click event
         */
        $scope.handleCheckHereClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                $scope.showImportedEntities();
            }
        };

        $scope.showImportedEntities = function () {

            return $mdDialog.show({
                multiple: true,
                clickOutsideToClose: true,
                templateUrl: 'partials/viewimportedentitiesdialog.html',
                controller: 'ViewImportedEntitiesDialogController',
                locals: {
                    importId,
                    deleteUpdated: $scope.deleteUpdatedObject.deleteUpdated,
                    entityName: $scope.entityName
                },
                bindToController: true,
                fullscreen: !$mdMedia('gt-md')
            });
        };

        $scope.deleteImport = function () {

            return $mdDialog.hide({ delete: true, deleteUpdated: $scope.deleteUpdatedObject.deleteUpdated });
        };
    }
})();
